import SeasonalRuleView from 'pages/calendar/common/seasonalRules/SeasonalRuleView';
import useVisibleSeasonalRules from './useVisibleSeasonalRules';

const SeasonalRuleRowLayer = ({ propertyUid }: { propertyUid: string }) => {
  const visibleRules = useVisibleSeasonalRules(propertyUid);
  if (!visibleRules.length) {
    return null;
  }
  return (
    <>
      {visibleRules.map(({ rule, leftPx, widthPx }) => (
        <SeasonalRuleView
          key={rule.ruleUid}
          rule={rule}
          propertyUid={propertyUid}
          leftPx={leftPx}
          widthPx={widthPx}
        />
      ))}
    </>
  );
};

export default SeasonalRuleRowLayer;
